module.exports = __webpack_public_path__ + "static/media/master.978b6e83.png";